(() => {
  const DRAG_THRESHOLD = 4;
  const PREVENT_CLICK_MS = 150;

  /**
   * @param {HTMLElement} root
   */
  function init(root) {
    const track = root.querySelector('.custom-reviews-slider__track');
    if (!track) return;
    if (track.hasAttribute('data-crs-initialized')) return;
    track.setAttribute('data-crs-initialized', 'true');

    /** @type {number | null} */
    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let dragging = false;
    let moved = false;
    let preventClick = false;
    let raf = /** @type {number | null} */ (null);
    let targetScrollLeft = 0;

    function applyScroll() {
      raf = null;
      track.scrollLeft = targetScrollLeft;
    }

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      pointerId = null;
      track.classList.remove('is-dragging');

      if (moved) {
        preventClick = true;
        window.setTimeout(() => {
          preventClick = false;
          moved = false;
        }, PREVENT_CLICK_MS);
      }
    }

    track.addEventListener('pointerdown', (e) => {
      // Only left-click for mouse; allow touch/pen.
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      pointerId = e.pointerId;
      startX = e.clientX;
      startScrollLeft = track.scrollLeft;
      targetScrollLeft = startScrollLeft;
      dragging = true;
      moved = false;

      track.classList.add('is-dragging');
      try {
        track.setPointerCapture(pointerId);
      } catch (_) {
        // ignore
      }
    });

    track.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      if (pointerId !== null && e.pointerId !== pointerId) return;

      const dx = e.clientX - startX;
      if (!moved && Math.abs(dx) >= DRAG_THRESHOLD) moved = true;

      // Drag direction: move pointer right => scroll left
      targetScrollLeft = startScrollLeft - dx;
      if (raf === null) raf = window.requestAnimationFrame(applyScroll);

      if (moved) e.preventDefault();
    });

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', () => {
      // If pointer is captured, leave won't fire meaningfully; safe to end anyway.
      endDrag();
    });

    // Prevent accidental clicks (links, selections) right after a drag.
    track.addEventListener(
      'click',
      (e) => {
        if (!preventClick) return;
        e.preventDefault();
        e.stopPropagation();
      },
      { capture: true }
    );
  }

  function initAll() {
    document.querySelectorAll('.custom-reviews-slider').forEach((root) => {
      if (!(root instanceof HTMLElement)) return;
      init(root);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (e) => {
    const target = /** @type {HTMLElement | null} */ (e.target);
    if (!target) return;
    const root = target.querySelector('.custom-reviews-slider');
    if (root instanceof HTMLElement) init(root);
  });
})();

